import { Box, Flex } from "@chakra-ui/react";
import { getRFQType, getDocumentType } from "actions/RFQ/rfqsAction";
import PreviewRfxDraft from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/components/PreviewRfxDraft";
import { TabHeader } from "components/TabHeader";
import { useEffect, useState } from "react";
import SkeletonBase from "newui/components/Skeleton";
import BackButton from "newui/components/BackButton";
import { ApprovalActionButton } from "pages/RFQ/Approval/components/ApprovalActionButton";
import { getRfxById } from "actions/RFQ/rfxActions";
import { RFX_INCLUDE } from "newui/features/Rfx/constants/rfx-constants";
import { showToast } from "utils/helpers";
import { logIfDebug } from "utils/logging";
import { navigate } from "@reach/router";
import { getSlug } from "helpers/linkHelper";
import {
	useCurrentCompany,
	useCurrentUser,
} from "hooks/auth";
import { useRfxData } from "newui/features/Rfx/data-provider/RfxDataProvider";

const ViewRFQPage = () => {
	const { hasRfxLoaded, rfxData, rfxId } = useRfxData();
	const [documentTypes, setDocumentType] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const { currentUser, isGuest } = useCurrentUser();
	const userId = currentUser?.id;
	const company = useCurrentCompany();

	const isApprover = rfxData?.rfxApprovers?.find(
		(approver) => approver.approverUserId === userId
	);

	useEffect(() => {
		setIsLoading(true);
		const res = async () => {
			return await Promise.all([
				getRfxById(rfxId, [RFX_INCLUDE.INVITED_SUPPLIERS]),
				getRFQType(),
				getDocumentType(),
			]);
		};

		res()
			.then((res) => {
				// setRFxData(res[0]);
				setDocumentType(
					res[2].map((doc) => ({ label: doc.name, value: doc.id }))
				);
			})
			.catch((_) => {
				logIfDebug(_.message, _.stack);
				showToast(
					"Error(s) whilst loading RFx, please try again.",
					"Error",
					false
				);
			})
			.finally(() => setIsLoading(false));
	}, [rfxId]);

	const handleBackButtonClick = () => {
		if (isApprover || isGuest) {
			navigate("/account/rfx");
			return;
		}
		navigate(
			`/account/${company.id}/rfx/${rfxId}/${getSlug(rfxData?.name)}/all`
		);
	};

	const showLoading = !hasRfxLoaded || isLoading;

	return (
		<>
			<TabHeader
				icon={<BackButton handleBackButtonClick={handleBackButtonClick} />}
			>
				<ApprovalActionButton
					rfx={rfxData}
					isLoading={showLoading}
				/>
			</TabHeader>
			{showLoading ? (
				<>
					<Box className="grid min-h-80 w-full content-between rounded-md border px-6 py-10 shadow-xl">
						<Flex className="flex-col gap-4 text-base font-semibold">
							<SkeletonBase width="280px" />
							<SkeletonBase width="500px" />
							<SkeletonBase width="500px" />
							<SkeletonBase width="500px" />
						</Flex>
					</Box>
					<div>
						<Flex className="flex-row gap-4 py-8 text-base font-semibold">
							<SkeletonBase />
							<SkeletonBase />
							<SkeletonBase />
							<SkeletonBase />
						</Flex>
					</div>
					<Box className="grid min-h-80 w-full content-between rounded-md border px-6 py-10 shadow-xl">
						<Flex className="flex-col gap-4 text-base font-semibold">
							<Flex gap={4}>
								<SkeletonBase />
								<SkeletonBase width="280px" />
							</Flex>
							<Flex gap={4}>
								<SkeletonBase />
								<SkeletonBase width="280px" />
							</Flex>
							<Flex gap={4}>
								<SkeletonBase />
								<SkeletonBase width="280px" />
							</Flex>
							<Flex gap={4}>
								<SkeletonBase />
								<SkeletonBase width="280px" />
							</Flex>
							<Flex gap={4}>
								<SkeletonBase />
								<SkeletonBase width="280px" />
							</Flex>
						</Flex>
					</Box>
				</>
			) : (
				<>
					<PreviewRfxDraft
						rfxData={rfxData}
						documentCategories={documentTypes}
						isDraftPreview={rfxData?.companyId === company?.id}
					/>
				</>
			)}
		</>
	);
};

export default ViewRFQPage;
